import { Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../../Context/Layout.context';
import usePermission, { UserPermission } from '../../../hooks/usePermission';
import {
  getConfigurationApi,
  getConfigurationApiDetails,
  getConfigurationApiDetailsOke,
} from '../../../services/admin/settings/systemSettings.service';
import { SelectableTable } from '../../SelectableTable/SelectableTable.component';
import { SelectableTableColumn } from '../../SelectableTable/SelectableTable.types';
import { useStyles } from './ConfigurationOke.styles';
import { ConfigurationOkeListItem, ConfigurationOkeDetails, ConfigurationOkeTableItem } from './ConfigurationOke.types';
import { Link } from '@mui/material';
import { EditConfigurationOke } from './EditConfigurationOke.component';
import { useTranslation } from 'react-i18next';
interface ConfigurationOkeProps {
  onClose: () => void;
  onChange: () => void;
}

export const ConfigurationOke: React.FC<ConfigurationOkeProps> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { showLoader } = useLayoutContext();

  const [configurationOkeList, setConfigurationOkeList] = useState<ConfigurationOkeListItem[]>([]);
  const [data, setData] = useState<ConfigurationOkeTableItem[]>([]);
  const [isEditAppSettingsModalOpen, setIsEditAppSettingsModalOpen] = useState<boolean>(false);
  const [configurationOkeDetails, setConfigurationOkeDetails] = useState<ConfigurationOkeDetails>();

  const hasAdminSettingsManagePermission = usePermission(UserPermission.AdminSettingsManage);

  const getData = () => {
    showLoader(true);
    getConfigurationApi(true)
      .then((result: ConfigurationOkeListItem[]) => {
        if (result) {
          setConfigurationOkeList(result); //Change to proper when bd will ready
        }
      })
      .finally(() => {
        showLoader(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleGetConfigurationOkeDetails = (id: string) => {
    if (id) {
      showLoader(true);
      getConfigurationApiDetailsOke(id)
        .then((result: ConfigurationOkeDetails) => {
          if (result) {
            setConfigurationOkeDetails(result); //Change to proper when bd will ready
            setIsEditAppSettingsModalOpen(true);
          }
        })
        .finally(() => {
          showLoader(false);
        });
    }
  };

  const handleOnClose = () => {
    setIsEditAppSettingsModalOpen(false);
    getData();
  };

  const getActionsMenuIcon = (id: string) => {
    return <Link style={{cursor: 'pointer'}} onClick={() => handleGetConfigurationOkeDetails(id)}>Edytuj</Link>;
  };

  // convert data for the tables
  useEffect(() => {
    if (configurationOkeList.length) {
      const tableData: ConfigurationOkeTableItem[] = configurationOkeList.map((row: ConfigurationOkeListItem) => ({
        name: row.name,
        actions: getActionsMenuIcon(row.configurationApiId),
      }));
      setData(tableData);
    }
  }, [configurationOkeList]);

  const columns: SelectableTableColumn[] = [
    {
      id: 'name',
      type: 'text',
      title: 'Nazwa',
      filterType: null,
      width: '90%',
    },
    {
      id: 'actions',
      type: 'actions',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.tabTitle}>{`Adresy API ${t('global:shortNames.OKE')}`}</Typography>
        <div className={classes.tableContainerFlex}>
          <SelectableTable<ConfigurationOkeTableItem>
            columns={columns}
            rows={data}
            caption={`Adresy API ${t('global:shortNames.OKE')}`}
          />
        </div>
        {isEditAppSettingsModalOpen && configurationOkeDetails && (
          <EditConfigurationOke
            title={`Edytuj adresy API ${t('global:shortNames.OKE')}`}
            data={configurationOkeDetails}
            onCancel={() => setIsEditAppSettingsModalOpen(false)}
            onClose={handleOnClose}
          />
        )}
      </Grid>
    </>
  );
};
